import React from 'react';

import * as S from './styles';

export const Slide6: React.FC = () => {
  return (
    <S.Container>
      <S.PhotoWrapper>
        <S.Photo />
      </S.PhotoWrapper>
      <S.Content>
        <S.Text>Beleza: Helder Rodrigues. Styling: Lucas Boccalão.</S.Text>
      </S.Content>
    </S.Container>
  );
};
